import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./slices/authSlice";
import uiReducer from "./slices/uiSlice";
import forexReducer from "./slices/forexSlice";
import countryReducer from "./slices/countrySlice";
import profileReducer from "./slices/profileSlice";
import settingsReducer from "./slices/settingsSlice";
import currencyReducer from "./slices/currencySlice";
import p2pMarketReducer from "./slices/p2pMarketSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  forex: forexReducer,
  country: countryReducer,
  profile: profileReducer,
  setting: settingsReducer,
  currency: currencyReducer,
  p2pMarket: p2pMarketReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  // getDefaultMiddleware({
  //   serializableCheck: {
  //     ignoredActions: ['auth/setUser'],
  //   },
  // }),
});

export let persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
